// extracted by mini-css-extract-plugin
module.exports = {"about":"about-module--about--2_TRk","arrow":"about-module--arrow--DBsrG","line":"about-module--line--3yR23","content":"about-module--content--1Gm07"};